import { Component, OnInit, ViewChild, forwardRef, Output, Input, EventEmitter, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { FormMode, ServiceStatus, AttachmentType, Languages, Service } from 'src/app/shared/models/enums.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { ActivatedRoute,Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors, ControlValueAccessor, Validator } from '@angular/forms';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { SupplierDTO, SupplierRegistrationLookups, Speciality, SupplierSpecialityDTO, Bank, SupplierCertificateTypes } from 'src/app/shared/models/e-tender.model';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { SupplierService } from 'src/app/shared/services/supplier.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { MembershipService } from '../../e-booking/shared/services/membership.service';
// import { debounceTime } from 'rxjs/operators';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { MyTasksService } from 'src/app/shared/services/my-Tasks.service';
// import { DebugRenderer2 } from '@angular/core/src/view/services';
// import { Observable } from "rxjs";

@Component({
  selector: 'supplier-registration-form',
  templateUrl: './supplier-registration.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SupplierRegistrationComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SupplierRegistrationComponent),
      multi: true
    }
  ]
})
export class SupplierRegistrationComponent implements OnInit, AfterViewInit, ControlValueAccessor, Validator {
  //#region PROPERTIES
  /////////////////////*Input - Outputs -ViewChild*/////////////////////
  @Input() public formSubmitted: boolean;
  @Input() public RequestStatus: number;
  @Input() public IsSupplierRegistrationType: boolean = true;
  @Input() SupplierIdInput: string;
  @Input() CategoryIdInput: string;
  @Input() IsInActivateStepInput: boolean;
  @Output() isLocalSupplier = new EventEmitter<boolean>();
  @Output() supplierEvent = new EventEmitter<SupplierDTO>();
  @Output() updatedSupplierEvent = new EventEmitter<SupplierDTO>();
  @Output() isSupplierFormValid = new EventEmitter<boolean>();
  /////////////////////*Tabs*/////////////////////
  @ViewChild('supplierTabs',{static: false}) supplierTabs: TabsetComponent;
  @ViewChild('supplierTabs',{static: false}) supplierTabsElementRef: ElementRef;
  @ViewChild('basicSupplierInfoTab',{static: false}) basicSupplierInfoTab: ElementRef;
  @ViewChild('supplierBanksTab',{static: false}) supplierBanksTab: ElementRef;
  @ViewChild('contactInfoTab',{static: false}) contactInfoTab: ElementRef;
  @ViewChild('supplierSpecialitiesTab',{static: false}) supplierSpecialitiesTab: ElementRef;
  @ViewChild('supplierPartnershipsTab',{static: false}) supplierPartnershipsTab: ElementRef;
  @ViewChild('supplierMaintenanceTab',{static: false}) supplierMaintenanceTab: ElementRef;
  @ViewChild('supplierCertificatesTab',{static: false}) supplierCertificatesTab: ElementRef;
  @ViewChild('formContainer',{static: false}) formContainerRef: ElementRef;


  isTabOneSubmitted: boolean = false;
  isTabTwoSubmitted: boolean = false;
  isTabThreeSubmitted: boolean = false;
  isTabFourSubmitted: boolean = false;
  isTabFiveSubmitted: boolean = false;
  isTabSixSubmitted: boolean = false;
  isTabSevenSubmitted: boolean = false;

  /////////////////////*Form Builder*/////////////////////
  supplierRegistrationForm: FormGroup;
  /////////////////////*Mode [Add - Edit - ReadOnly]*/////////////////////
  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  /////////////////////*Lookups*/////////////////////
  public supplierRegistrationLookups: SupplierRegistrationLookups;
  supplierNatures: LookUp[];
  supplierTypes: LookUp[];
  contractorCategories: LookUp[];
  contractorClassifications: LookUp[];
  specialities: Speciality[];
  specialitiesFilteredByCategoryID: Speciality[];
  supplierAccountStatuses: LookUp[];
  governorates: LookUp[];
  currencies: LookUp[];
  categories: LookUp[];
  nationalities: LookUp[];
  banks: Bank[];
  supplierCertificateTypes = SupplierCertificateTypes;
  supplierCertificateTypesKeys = Object.keys(this.supplierCertificateTypes);  
  multiDropDownSettings = {};
  multiDropDownSettingsCats = {};
  /////////////////////*Language*/////////////////////
  public Languages: any = Languages;
  public currentLanguage: any;
  /////////////////////*Regular Expressions */////////////////////
  emailRegex: string = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";
  // emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  numberRegex: string = '^[0-9]*$';
  // decimalNumberRegex: string = '/^[0-9]*+.+[0-9]*$/';
  numberLettersDashRegex: string = '^[0-9]*$';
  decimalNumberRegex: string = '^((([0-9])*)((\\.[0-9]{1,7})?)|([0-9])+((\\.[0-9]{1,7}))|([0-9])+((\\.)))$';
  websiteRegex: RegExp = /^(http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  // taxRecordNumberRegex: RegExp = /^([a-z\d]+\-){2}[a-z\d]+$/i;
  taxRecordNumberRegex: RegExp = /^([\d]+\-){2}[\d]+$/i;
  /////////////////////*Uploaders*/////////////////////
  uploadedFileName: string;
  public supplierRegistrationFormAttachments: Attachment[] = [];
  commericalRecordCopyProgress: number;
  taxCardCopyProgress: number;
  vatRegistrationCopyProgress: number;
  publicationOfficialGazetteCopyProgress: number;
  activityLegalRegistrationCopyProgress: number;
  clientsEntitiesPreviousWorksCopyProgress: number;
  lastTwoYearsBalanceSheetCopyProgress: number;
  companyContractCopyProgress: number;
  contructorCategoryCopyProgress: number;
  contructorClassificationCopyProgress: number;
  contactPersonIDCopyProgress: number;
  partnershipAttachmentProgress: number;
  catgoryExperienceProgress: number;

  //In ReadOnly - AdminEditMode  Mode
  commericalRecordCopyAttachment: Attachment;
  taxCardCopyAttachment: Attachment;
  vatRegistrationCopyAttachment: Attachment;
  publicationOfficialGazetteCopyAttachment: Attachment;
  activityLegalRegistrationCopyAttachment: Attachment;
  clientsEntitiesPreviousWorksCopyAttachment: Attachment;
  lastTwoYearsBalanceSheetCopyAttachment: Attachment;
  companyContractCopyAttachment: Attachment;
  contructorCategoryCopyAttachment: Attachment;
  contructorClassificationCopyAttachment: Attachment;
  contactPersonIDCopyAttachment: Attachment;
  partnershipAttachmentAttachment: Attachment;
  catgoryExperienceAttachment: Attachment;
  /////////////////////*Objects*/////////////////////
  public supplierInfo: SupplierDTO = new SupplierDTO();
  private responseObj: ResponseObject = new ResponseObject();
  public basicRegistrationInfoResponseObj: ResponseObject = new ResponseObject();
  /////////////////////*Properties*/////////////////////
  public selectedSupplierPartnershipCategoriesIds: number[];
  public allSelectedSupplierPartnershipCategoriesIds: number[][] = new Array();
  public showUnderconstructionMessage = false;
  private supplierId: string = "";
  private baseRequestDTO: BaseRequest //= new BaseRequest();
  private currentUser: User = new User();
  private filteredSupplierSpicialitiesByCatId: SupplierSpecialityDTO[] = new Array();
  private uploadUrl: string = AppConfig.settings.apiServer.UploadsUrl + AppConfig.settings.apiServer.ETenderUploadsFolder + "/";
  // private uploadUrl: string = AppConfig.settings.apiServer.UploadsUrl;
  private supplierTypeId;
  /////////////////////*Edit Supplier Profile*/////////////////////
  private UpdatedSupplier: SupplierDTO = new SupplierDTO();
  private isFormArrayControlsDisabled: boolean = false;
  private specialitiesCategoriesIds: number[];
  private disticntAcceptedCategoriesIds: number[];
  private deletedSpecialityCategorId: number;
  private supplierSpecialityFromDB: SupplierSpecialityDTO[] = new Array();
  private deletedSupplierSpecialities: SupplierSpecialityDTO[] = new Array();
  public editCompleted: boolean = false;
  private isAllCategories: boolean = false;
  private isMyMessages: boolean = false;
  public isAccountReview: boolean = false;
  private deleteSupplierSpecialityPopUpMessage: string;//="Are you sure?";
  public submitFail: boolean = false;
  private basicInfoSupplierType: string;
  private myTasksUrl: string;
  private workspaceUrl: string;
  private datePlaceHolder: string;
  public requestId: string;
  private isTaxRecordNumberDuplicated: boolean = false;
  private supplierNumber: string;
  private isRequestHistory: boolean = false;
  private wfAppInstanceId: string;
  private baseRequestIdFromRqHistory: string;
  private categoryIdFromRqHistory: string;
  private isCategoryRejected: boolean = false;
  private categoryRejectionReason: string;
  private isActivate: boolean = false;
  public islastCategoryAccepted: boolean = false;
  private slectedSpeciatilty: SupplierSpecialityDTO[] = new Array();
  private repeatedSpecialityErrorMessage: string;
  public fixedTimeGMT: string = ",12:00:00 PM";
  private selectedCats: any = [];
  private PendingAdminTasks: any = [];
  // private categoryTaskStatus: any = [];
  // public IsSupplierRegistrationAvailable: Observable<boolean>;
  public IsSupplierRegistrationAvailable: boolean;
  public registrationAvailability: number[] = [];
  public MonthNames: GenericLookup[] = [
    { Id: 1, NameEN: 'January', NameAR: 'يناير' },
    { Id: 2, NameEN: 'February', NameAR: 'فبراير' },
    { Id: 3, NameEN: 'March', NameAR: 'مارس' },
    { Id: 4, NameEN: 'April', NameAR: 'أبريل' },
    { Id: 5, NameEN: 'May', NameAR: 'مايو' },
    { Id: 6, NameEN: 'June', NameAR: 'يونيو' },
    { Id: 7, NameEN: 'July', NameAR: 'يوليو' },
    { Id: 8, NameEN: 'August', NameAR: 'أغسطس' },
    { Id: 9, NameEN: 'September', NameAR: 'سبتمبر' },
    { Id: 10, NameEN: 'October', NameAR: 'أكتوبر' },
    { Id: 11, NameEN: 'November', NameAR: 'نوفمبر' },
    { Id: 12, NameEN: 'December', NameAR: 'ديسمبر' },
  ];
  showCertificateTypeOther: number[] = [];


  //#endregion

  //#region CONSTRUCTOR
  constructor(
    private lookupService: LookupService,
    private translate: TranslateService,
    private fileService: fileService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private globalServices: GlobalServices,
    private supplierService: SupplierService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private baseRequestService: BaseRequestService,
    private membershipService: MembershipService,
    private authSrevice: AuthenticationService,
    private alertService: AlertService,
    private myTasksService: MyTasksService
  ) {
    this.IsSupplierRegistrationAvailable = true;
    this.supplierCertificateTypesKeys = this.supplierCertificateTypesKeys.slice(this.supplierCertificateTypesKeys.length / 2);
    // this.isActivate = this.IsInActivateStepInput;
    this.editCompleted = false;
    this.currentLanguage = this.globalServices.getLanguage();
    if (this.currentLanguage == Languages.English) {
      // this.myTasksUrl = "/English/Pages/Workspace.aspx#/myTasks";
      // this.workspaceUrl = "/English/Pages/Workspace.aspx#/workspace";
      this.myTasksUrl = "/English" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
      this.workspaceUrl = "/English" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "workspace";
      this.datePlaceHolder = "year-month-day";
    } else {
      // this.myTasksUrl = "/Arabic/Pages/Workspace.aspx#/myTasks";
      // this.workspaceUrl = "/Arabic/Pages/Workspace.aspx#/workspace";
      this.myTasksUrl = "/Arabic" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "myTasks";
      this.workspaceUrl = "/Arabic" + AppConfig.settings.apiServer.RelativeIndexPageUrl + "workspace";
      this.datePlaceHolder = "سنة-شهر-يوم";
    }

    this.currentUser = authSrevice.currentUserValue;
    // this.currentUser = this.globalServices.user;

    if (history.state.data && history.state.data.requestId) {
      this.supplierId = history.state.data.requestId;
      if (history.state.data.isAllCategories) {
        this.isAllCategories = history.state.data.isAllCategories;
      }
      if (history.state.data.isMyMessages) {
        this.isMyMessages = history.state.data.isMyMessages;
      }

      if (history.state.data.isCompleted) {
        this.isRequestHistory = history.state.data.isCompleted;
        this.wfAppInstanceId = history.state.data.appInstanceId;
        var splits = this.wfAppInstanceId.split("_")
        this.baseRequestIdFromRqHistory = splits[0];
        this.categoryIdFromRqHistory = splits[1];
      }


    }
    else if (this.currentUser && !this.currentUser.IsAdmin && this.currentUser.UserId) {
      this.supplierId = this.currentUser.UserId;
    }
    else if(this.currentUser && this.currentUser.IsAdmin){
      window.history.back();
      // this.supplierId = "730EED31-4232-4819-BE18-B50ACCF56CDF";
      // this.supplierId = "D6628F24-D5F1-4805-873D-E0C302F6CEAE";
      // this.supplierId = "73B0E9CC-205D-412D-9F39-46FF14F1B2F8";
      //add case of user from global
      //  this.globalServices.goToHome();
    }

    // else if (this.router.snapshot.params.Id != undefined) {
    //   // Simulate the Edit - Read Only Modes
    //   this.supplierId = this.router.snapshot.params.Id;
    // }

    if (this.supplierId) {
      this.baseRequestService.GetLastCreatedIdByUserId(this.supplierId, Service.SupplierRegistration).subscribe(
        data => this.requestId = data.Data,
        () => this.submitFail = true
      );

      this.membershipService.GetAspUser(this.supplierId).subscribe(
        data => this.basicRegistrationInfoResponseObj = data,
        () => this.submitFail = true
      );

    }
    this.translate.get('ADMIN_USER.SUPPPLIER_FORMS.Supplier').subscribe(
      data => this.basicInfoSupplierType = data
    );
    this.translate.get('FRONT_USER.ERRORS_MESSAGES.RepeatedSpecialityErrorMessage').subscribe(
      data => this.repeatedSpecialityErrorMessage = data
    );

    this.BuildSupplierRegistrationForm();
    this.supplierService.CheckRegistrationAvailability()
    .subscribe((data) => {
        this.IsSupplierRegistrationAvailable = data.Success;
        this.registrationAvailability = data.Data as number[];
    });
  }
  //#endregion

  //#region EVENTS
  ngOnInit() {
    this.globalServices.isLoaderEnabled = true;
    if (this.SupplierIdInput) {
      //the SupplierId from my tasks in purchasing/technical approvals and from supplier listing
      this.supplierId = this.SupplierIdInput;
    }
    //Enable Loader to wait for Lookups
    this.loadAllLookUps();

    if (this.supplierId) {
      this.baseRequestService.GetLastCreatedByUserId(this.supplierId, Service.SupplierRegistration).subscribe(
        d => {
          this.baseRequestDTO = d.Data;
          this.RequestStatus = this.baseRequestDTO.StatusId;
          if (this.isRequestHistory) {
            // Readonly Mode
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.formMode = FormMode.Readonly;
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          } else if (this.baseRequestDTO.StatusId == ServiceStatus.PendingOnAdminApproval && this.currentUser.IsAdmin && !this.isAllCategories) {
            // Aproval [Purchasing/Technical Category Admins] => Readonly Mode
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.formMode = FormMode.Readonly;
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          } else if (this.baseRequestDTO.StatusId == ServiceStatus.RegistrationAccepted && this.currentUser.IsAdmin && this.isAllCategories) {
            // => Admin Edit Mode [Can Edit : Specialty-Partner Name]
            this.formMode = FormMode.AdminEdit;
            this.isFormArrayControlsDisabled = true;
            this.getFormControls["IsLocalSupplier"].disable();
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          } else if (this.baseRequestDTO.StatusId == ServiceStatus.RegistrationAccepted && !this.currentUser.IsAdmin) {
            // => User Edit Mode [Can Edit : All Form]
            this.isFormArrayControlsDisabled = false;
            this.formMode = FormMode.Edit;
            this.getFormControls["IsLocalSupplier"].disable();
            const CommericalRecordCopy = this.getBasicSupplierInfoTabControls['CommericalRecordCopy'];
            CommericalRecordCopy.clearValidators();
            CommericalRecordCopy.setValue('');
            this.commericalRecordCopyProgress = 0;
            CommericalRecordCopy.updateValueAndValidity();

            const TaxCardCopy = this.getBasicSupplierInfoTabControls['TaxCardCopy'];
            TaxCardCopy.clearValidators();
            TaxCardCopy.setValue('');
            this.taxCardCopyProgress = 0;
            TaxCardCopy.updateValueAndValidity();

            const VATRegistrationCopy = this.getBasicSupplierInfoTabControls['VATRegistrationCopy'];
            VATRegistrationCopy.clearValidators();
            VATRegistrationCopy.setValue('');
            this.vatRegistrationCopyProgress = 0;
            VATRegistrationCopy.updateValueAndValidity();

            const PublicationOfficialGazetteCopy = this.getBasicSupplierInfoTabControls['PublicationOfficialGazetteCopy'];
            PublicationOfficialGazetteCopy.clearValidators();
            PublicationOfficialGazetteCopy.setValue('');
            this.publicationOfficialGazetteCopyProgress = 0;
            PublicationOfficialGazetteCopy.updateValueAndValidity();

            const ActivityLegalRegistrationCopy = this.getBasicSupplierInfoTabControls['ActivityLegalRegistrationCopy'];
            ActivityLegalRegistrationCopy.clearValidators();
            ActivityLegalRegistrationCopy.setValue('');
            this.activityLegalRegistrationCopyProgress = 0;
            ActivityLegalRegistrationCopy.updateValueAndValidity();

            const ClientsEntitiesPreviousWorksCopy = this.getBasicSupplierInfoTabControls['ClientsEntitiesPreviousWorksCopy'];
            ClientsEntitiesPreviousWorksCopy.clearValidators();
            ClientsEntitiesPreviousWorksCopy.setValue('');
            this.clientsEntitiesPreviousWorksCopyProgress = 0;
            ClientsEntitiesPreviousWorksCopy.updateValueAndValidity();

            const LastTwoYearsBalanceSheetCopy = this.getBasicSupplierInfoTabControls['LastTwoYearsBalanceSheetCopy'];
            LastTwoYearsBalanceSheetCopy.clearValidators();
            LastTwoYearsBalanceSheetCopy.setValue('');
            this.lastTwoYearsBalanceSheetCopyProgress = 0;
            LastTwoYearsBalanceSheetCopy.updateValueAndValidity();

            const CompanyContractCopy = this.getBasicSupplierInfoTabControls['CompanyContractCopy'];
            // CompanyContractCopy.clearValidators();
            // CompanyContractCopy.setValue('');
            this.companyContractCopyProgress = 0;
            // CompanyContractCopy.updateValueAndValidity();

            const ContructorCategoryCopy = this.getBasicSupplierInfoTabControls['ContructorCategoryCopy'];
            ContructorCategoryCopy.clearValidators();
            ContructorCategoryCopy.setValue('');
            this.contructorCategoryCopyProgress = 0;
            ContructorCategoryCopy.updateValueAndValidity();

            const ContructorClassificationCopy = this.getBasicSupplierInfoTabControls['ContructorClassificationCopy'];
            ContructorClassificationCopy.clearValidators();
            ContructorClassificationCopy.setValue('');
            this.contructorClassificationCopyProgress = 0;
            ContructorClassificationCopy.updateValueAndValidity();

            const ContactPersonIDCopy = this.getContactInfoTabControls['ContactPersonIDCopy'];
            ContactPersonIDCopy.clearValidators();
            ContactPersonIDCopy.setValue('');
            this.contactPersonIDCopyProgress = 0;
            ContactPersonIDCopy.updateValueAndValidity();
          } else if (this.baseRequestDTO.StatusId == ServiceStatus.PendingOnAdminApproval && !this.currentUser.IsAdmin) {
            // Account is in review [Upon User edit]
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.formMode = FormMode.Readonly;
            this.isAccountReview = true;
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          } else if (this.baseRequestDTO.StatusId == ServiceStatus.PendingOnAdminApproval && this.currentUser.IsAdmin && this.isAllCategories) {
            // Account is in review [Upon User edit]=> Readonly Mode from listing
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.formMode = FormMode.Readonly;
            this.isAccountReview = true;
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
            this.getAdminTasks();
          } else {
            // Readonly Mode
            this.supplierRegistrationForm.disable();
            this.supplierRegistrationForm.get('SupplierSpecialities').disable();
            this.formMode = FormMode.Readonly;
            this.isFormArrayControlsDisabled = true;
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          }

          if (this.formMode == FormMode.Readonly || this.formMode == FormMode.AdminEdit || this.formMode == FormMode.Edit) {
            this.supplierTabs.tabs[1].disabled = false;
            this.supplierTabs.tabs[2].disabled = false;
            this.supplierTabs.tabs[3].disabled = false;
            this.supplierTabs.tabs[4].disabled = false;
            this.supplierTabs.tabs[5].disabled = false;
            this.supplierTabs.tabs[6].disabled = false;
            this.changeDetectorRef.detectChanges();
          }
        },
        () => this.submitFail = true,
        () => this.getSupplierData()
      );
      //this.getSupplierData();
    } else if (this.formMode == FormMode.Add) {
      //Add the first object in SupplierBanks-SupplierSpecialities-SupplierPartnerships FormArray [FormMode="Add"]
      if (!this.supplierId) {
        this.AddSupplierBank();
        this.AddSupplierSpeciality(0, false);
        // this.AddSupplierCertificate();
        // this.AddSupplierPartnership();  
      }
    }  
  }

  getCorrespondingMonthNames(): string[] {
    return this.registrationAvailability.map((monthNumber) => {
      const monthId = +monthNumber; // Convert the string to a number using the `+` operator
      const month = this.MonthNames.find((m) => m.Id === monthId);
      return month ? (this.currentLanguage === Languages.English ? month.NameEN : month.NameAR) : 'Unknown';
    });
  }
  get getFormattedMonthNames(): string {
    return this.getCorrespondingMonthNames().join(' / ');
  }
  getAdminTasks() {
    this.globalServices.isLoaderEnabled = true;
    this.myTasksService.getAdminTasksByRequestId(this.currentUser.UserName, this.baseRequestDTO.Id).subscribe(
      data => this.PendingAdminTasks = data.Data,
      () => console.log('Something went wrong!!'),
      () => this.globalServices.isLoaderEnabled = false,
      // () => this.getAdminTasksCompleted(),
    );
  }
  getAdminTasksCompleted(): void {
    // if (this.selectedCats != ""){
    //   this.selectedCats.forEach(element => {
    //     this.categoryTaskStatus.push(this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == element[0].Id).Status);
    //   });
    //   this.globalServices.isLoaderEnabled = false;
    // }
  }
  getCategoryTaskStatus(i){
    if (this.PendingAdminTasks.Collection && this.PendingAdminTasks.Collection.length > 0){
      if(this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == this.selectedCats[i][0].Id)){
        return this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == this.selectedCats[i][0].Id).Status;
      }
    }
  }
  navigateToTask(i){
    if (this.PendingAdminTasks.Collection && this.PendingAdminTasks.Collection.length > 0){
    var navigateUrl = this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == this.selectedCats[i][0].Id).Url;
    var requestId = this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == this.selectedCats[i][0].Id).RequestId;
    var appInstanceId = this.PendingAdminTasks.Collection.find(s => s.AppInstanceID.split("_")[1] == this.selectedCats[i][0].Id).AppInstanceID;
    this.router.navigate([navigateUrl], { state: { data: { requestId, appInstanceId } } });
    }
  }
  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }
  //#endregion

  //#region FUNCTIONS
  //#region FormBuilder Functions
  BuildSupplierRegistrationForm() {
    this.supplierRegistrationForm = this.formBuilder.group({
      IsLocalSupplier: new FormControl('', Validators.required),
      BasicSupplierInfoTab: this.formBuilder.group({
        UserId: new FormControl(''),
        SupplierNatureId: new FormControl('', Validators.required),
        SupplierTypeId: new FormControl('', Validators.required),
        CompanyName: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
        CommercialName: new FormControl('', [Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
        //Supplier Type != industrial
        CommercialRecordNumber: new FormControl(''),
        CommericalRecordCopy: new FormControl(''),
        CommercialRecordExpiryDate: new FormControl(''),
        //Supplier Type == industrial
        IndustrialRegistrationNumber: new FormControl(''),
        TaxRecordNumber: new FormControl('', [Validators.required, Validators.pattern(this.taxRecordNumberRegex), Validators.maxLength(50)]),
        // TaxCardNumber: new FormControl('', [Validators.required, Validators.pattern(this.taxRecordNumberRegex), Validators.maxLength(50), CustomValidators.textSpaceValidator()]),
        TaxCardExpiryDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        TaxAuthority: new FormControl('', [Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]),
        TaxCardCopy: new FormControl('', Validators.required),
        VATRegCheck: new FormControl('true'),
        VATRegistrationDate: new FormControl('', [Validators.required, CustomValidators.pastDateValidator()]),
        VATNumber: new FormControl('', [Validators.required, Validators.pattern(this.taxRecordNumberRegex), Validators.maxLength(50), CustomValidators.textSpaceValidator()]),
        VATRegistrationCopy: new FormControl('', Validators.required),
        PublicationOfficialGazetteCopy: new FormControl(''),//, Validators.required
        ActivityLegalRecordRegistrationNumber: new FormControl('', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]),//, Validators.required
        ActivityLegalRecordRegistrationDate: new FormControl('', [CustomValidators.pastDateValidator()]),//Validators.required,
        ActivityLegalRegistrationCopy: new FormControl(''),//, Validators.required
        ClientsEntitiesPreviousWorksCopy: new FormControl(''),//, Validators.required
        PaidCapital: new FormControl('', [Validators.required, Validators.pattern(this.decimalNumberRegex), Validators.maxLength(50)]),
        CompanyEstablishingDate: new FormControl('', [Validators.required, CustomValidators.pastDateValidator()]),
        AverageAnnualTurnover: new FormControl('', [Validators.pattern(this.decimalNumberRegex), Validators.maxLength(50)]),//Validators.required,
        AverageAnnualTurnoverCurrencyId: new FormControl({ value: '', disabled: true }), //new FormControl(''),//, Validators.required),
        LastTwoYearsBalanceSheetCopy: new FormControl('', Validators.required),
        CompanyContractCopy: new FormControl(''),//, Validators.required),
        ConstructionNumber: new FormControl(''),//, Validators.required),
        ContractorCategoryId: new FormControl(''),//, Validators.required),
        ContructorCategoryCopy: new FormControl(''),//, Validators.required),
        ContractorClassificationId: new FormControl(''),//, Validators.required),
        ContructorClassificationCopy: new FormControl('')//, Validators.required),
      }),
      ContactInfoTab: this.formBuilder.group({
        Address: new FormControl('', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]),
        PostalCode: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex), Validators.maxLength(50)]),
        ContactPersonName: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
        ContactPersonIDCopy: new FormControl('', Validators.required),
        Phone: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex), Validators.maxLength(11)]),
        Fax: new FormControl('', [Validators.pattern(this.numberRegex), Validators.maxLength(50)]),//Validators.required,
        ContactPersonEmail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator(), Validators.maxLength(50)]),
        GovernorateId: new FormControl('', Validators.required),
        WebSiteURL: new FormControl('', [Validators.pattern(this.websiteRegex), Validators.maxLength(50)])//Validators.required,
      }),
      SupplierMaintenanceTab: this.formBuilder.group({
        MaintenanceCenterAddress: new FormControl('', [Validators.maxLength(500), CustomValidators.textSpaceValidator()]),
        MaintenanceContactPerson: new FormControl('', [Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
        MaintenancePhone: new FormControl('', [Validators.pattern(this.numberRegex), Validators.maxLength(11)]),
        MaintenanceFax: new FormControl('', [Validators.pattern(this.numberRegex), Validators.maxLength(50)])
      }),
      RatingScale: new FormControl(''),
      AccountStatusId: new FormControl(''),
      DisableReason: new FormControl(''),
      SupplierBanks: this.formBuilder.array([]),
      SupplierSpecialities: this.formBuilder.array([]),
      SupplierPartnerships: this.formBuilder.array([]),
      SupplierCertificates: this.formBuilder.array([])
    });
  }
  getSupplierData() {
    this.globalServices.isLoaderEnabled = true;
    this.supplierService.GetSupplier(this.supplierId).subscribe(
      data => this.responseObj = data,
      () => this.submitFail = true,
      () => this.bindSupplierData()
    );
  }
  bindSupplierData() {
    if (this.responseObj.Success) {
      this.commericalRecordCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierCommericalRecord);
      if (this.commericalRecordCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.commericalRecordCopyAttachment);
      }

      this.taxCardCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierTaxCard);
      if (this.taxCardCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.taxCardCopyAttachment);
      }

      this.vatRegistrationCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierVATRegisteration);
      if (this.vatRegistrationCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.vatRegistrationCopyAttachment);
      }


      this.publicationOfficialGazetteCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierPublicationInTheOfficialGazette);
      if (this.publicationOfficialGazetteCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.publicationOfficialGazetteCopyAttachment);
      }

      this.activityLegalRegistrationCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierActivityLegalRecordRegistration);
      if (this.activityLegalRegistrationCopyAttachment != null) {

        this.supplierRegistrationFormAttachments.push(this.activityLegalRegistrationCopyAttachment);
      }

      this.clientsEntitiesPreviousWorksCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierClientsEntitesPreviousWorks);
      if (this.clientsEntitiesPreviousWorksCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.clientsEntitiesPreviousWorksCopyAttachment);

      }

      this.lastTwoYearsBalanceSheetCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierLastTwoYearsBalanceSheet);
      if (this.lastTwoYearsBalanceSheetCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.lastTwoYearsBalanceSheetCopyAttachment);
      }

      this.companyContractCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierCompanyContract);
      if (this.companyContractCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.companyContractCopyAttachment);
      }

      this.contructorCategoryCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierConstructorCategory);
      if (this.contructorCategoryCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.contructorCategoryCopyAttachment);
      }

      this.contructorClassificationCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierConstructorClassification);
      if (this.contructorClassificationCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.contructorClassificationCopyAttachment);
      }

      this.contactPersonIDCopyAttachment = this.responseObj.Data.BaseUser.BaseRequests[0].Attachments.find(a => a.AttachmentTypeId == AttachmentType.SupplierContactPersonID);
      if (this.contactPersonIDCopyAttachment != null) {
        this.supplierRegistrationFormAttachments.push(this.contactPersonIDCopyAttachment);
      }

      //Supplier Specialities Filtration
      if (this.formMode == FormMode.Readonly) {
        if (this.isRequestHistory) {
          //Request History Form => Readonly Mode and Conserned Category
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'].filter(ss => ss.Speciality.CategoryId == +this.categoryIdFromRqHistory);
          if (this.filteredSupplierSpicialitiesByCatId[0].Status == 0) {
            this.isCategoryRejected = true;
            if (this.filteredSupplierSpicialitiesByCatId[0].PurchasingAdminRejectionReason) {
              this.categoryRejectionReason = this.filteredSupplierSpicialitiesByCatId[0].PurchasingAdminRejectionReason;
            } else if (this.filteredSupplierSpicialitiesByCatId[0].TechnicalAdminRejectionReason) {
              this.categoryRejectionReason = this.filteredSupplierSpicialitiesByCatId[0].TechnicalAdminRejectionReason;
            }
          }
        } else if (this.IsInActivateStepInput) {
          //SupplierActivate Form => Readonly Mode and All Category [Accepted - not removed - not pending]
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'].filter(ss => ss.Status == 1);
        } else if (this.isAllCategories) {
          //View pendeing registration from supplier listing Form => Readonly Mode and All Category [Accepted - removed - pending]
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'];
        } else if (this.isMyMessages) {
          //View all registration from myMessages Listing Form => Readonly Mode and All Category [Accepted - removed - pending]
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'];
        } else if (this.isAccountReview) {
          //Account is in review [Upon User Edit] => Readonly Mode and All Category [Accepted - not removed - not pending]
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'].filter(ss => ss.Status == 1);
        } else {
          // Aproval [Purchasing/Technical Category Admins] Form => Readonly Mode and Conserned Category
          this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'].filter(ss => ss.Speciality.CategoryId == +this.CategoryIdInput).filter(ss => ss.Status != 0).filter(ss => ss.Status != 3);
        }
      } else if (this.formMode == FormMode.AdminEdit) {
        //Supplier Update Form => Admin Edit Mode and All Category [Accepted Only]
        this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'];//.filter(ss => ss.Status == 1);
        this.supplierSpecialityFromDB = this.filteredSupplierSpicialitiesByCatId;
        this.disticntAcceptedCategoriesIds = this.filteredSupplierSpicialitiesByCatId.map(function (currItem) {
          return currItem.Speciality.CategoryId;
        });
        this.disticntAcceptedCategoriesIds = this.disticntAcceptedCategoriesIds.filter(this.onlyUnique);
      } else if (this.formMode == FormMode.Edit) {
        //Supplier Update Form => User Edit Mode and All Category [Accepted Only]
        this.filteredSupplierSpicialitiesByCatId = this.responseObj.Data['SupplierSpecialities'].filter(ss => ss.Status == 1);
        this.supplierSpecialityFromDB = this.filteredSupplierSpicialitiesByCatId;
        //Get accepted categories IDs disticnt
        this.disticntAcceptedCategoriesIds = this.filteredSupplierSpicialitiesByCatId.map(function (currItem) {
          return currItem.Speciality.CategoryId;
        });
        this.disticntAcceptedCategoriesIds = this.disticntAcceptedCategoriesIds.filter(this.onlyUnique);
      }
      //Set value of VAT Registration Check Control
      // In case the VAT number retrieved empty or NULL, then the company is not registered in VAT
      let VATRegCheckControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATRegCheck"];
      let VATNumberControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATNumber"];
      let VATRegistrationDateControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATRegistrationDate"];
      let VATRegCheckControlValue = 'true';
      if(this.responseObj.Data['VATNumber'] == "" || this.responseObj.Data['VATNumber'] == null){

        VATRegCheckControl.setValue(false);
        VATRegCheckControlValue = 'false';
        VATRegCheckControl.updateValueAndValidity();
        VATNumberControl.setValue('');
        VATNumberControl.clearValidators();
        VATNumberControl.updateValueAndValidity();
        VATRegistrationDateControl.setValue(null);
        VATRegistrationDateControl.clearValidators();
        VATRegistrationDateControl.updateValueAndValidity();
      }else{
        //Companies that are registered in VAT can't change their registration status
        //We disable the radio check control so that not to change the status
        VATRegCheckControl.disable();
      }

      this.supplierRegistrationForm.patchValue({
        IsLocalSupplier: this.responseObj.Data['IsLocalSupplier'],
      });
      this.supplierTypeId = this.responseObj.Data['SupplierTypeId'];
      this.supplierNumber = this.responseObj.Data['SupplierNumber'];
      this.onSupplierTypeChange(this.responseObj.Data['SupplierTypeId'].value);
      this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].patchValue({
        SupplierNatureId: this.responseObj.Data['SupplierNatureId'],
        SupplierTypeId: this.responseObj.Data['SupplierTypeId'],
        CompanyName: this.responseObj.Data['CompanyName'],
        CommercialName: this.responseObj.Data['CommercialName'],
        CommercialRecordNumber: this.responseObj.Data['CommercialRecordNumber'],
        // CommericalRecordCopy: this.responseObj.Data['CommericalRecordCopy'],
        CommercialRecordExpiryDate: this.responseObj.Data['CommercialRecordExpiryDate'],
        IndustrialRegistrationNumber: this.responseObj.Data['IndustrialRegistrationNumber'],
        TaxRecordNumber: this.responseObj.Data['TaxRecordNumber'],
        // TaxCardNumber: this.responseObj.Data['TaxCardNumber'],
        TaxCardExpiryDate: this.responseObj.Data['TaxCardExpiryDate'],
        TaxAuthority: this.responseObj.Data['TaxAuthority'],
        // TaxCardCopy: this.responseObj.Data['TaxCardCopy'],
        TaxCardCopy: this.responseObj.Data['TaxCardCopy'],
        VATRegistrationDate: this.responseObj.Data['VATRegistrationDate'],
        VATNumber: this.responseObj.Data['VATNumber'],
        VATRegCheck:VATRegCheckControlValue,
        ActivityLegalRecordRegistrationNumber: this.responseObj.Data['ActivityLegalRecordRegistrationNumber'],
        ActivityLegalRecordRegistrationDate: this.responseObj.Data['ActivityLegalRecordRegistrationDate'],
        PaidCapital: this.responseObj.Data['PaidCapital'],
        CompanyEstablishingDate: this.responseObj.Data['CompanyEstablishingDate'],
        AverageAnnualTurnover: this.responseObj.Data['AverageAnnualTurnover'],
        AverageAnnualTurnoverCurrencyId: this.responseObj.Data['AverageAnnualTurnoverCurrencyId'],
        ConstructionNumber: this.responseObj.Data['ConstructionNumber'],
        ContractorCategoryId: this.responseObj.Data['ContractorCategoryId'],
        ContractorClassificationId: this.responseObj.Data['ContractorClassificationId'],
      });
      this.supplierRegistrationForm.setControl('SupplierBanks', this.getSupplierBanksData(this.responseObj.Data['SupplierBanks']));
      this.supplierRegistrationForm.controls['ContactInfoTab'].patchValue({
        Address: this.responseObj.Data['Address'],
        PostalCode: this.responseObj.Data['PostalCode'],
        ContactPersonName: this.responseObj.Data['ContactPersonName'],
        Phone: this.responseObj.Data['Phone'],
        Fax: this.responseObj.Data['Fax'],
        ContactPersonEmail: this.responseObj.Data['ContactPersonEmail'],
        GovernorateId: this.responseObj.Data['GovernorateId'],
        WebSiteURL: this.responseObj.Data['WebSiteURL']
      });
      this.supplierRegistrationForm.setControl('SupplierSpecialities', this.getSupplierSpecialitiesData(this.filteredSupplierSpicialitiesByCatId));
      this.supplierRegistrationForm.setControl('SupplierPartnerships', this.getSupplierPartnershipsData(this.responseObj.Data['SupplierPartnerships']));
      this.supplierRegistrationForm.setControl('SupplierCertificates', this.getSupplierCertificatesData(this.responseObj.Data['SupplierCertificates']));
      this.supplierRegistrationForm.controls['SupplierMaintenanceTab'].patchValue({
        MaintenanceCenterAddress: this.responseObj.Data['MaintenanceCenterAddress'],
        MaintenanceContactPerson: this.responseObj.Data['MaintenanceContactPerson'],
        MaintenancePhone: this.responseObj.Data['MaintenancePhone'],
        MaintenanceFax: this.responseObj.Data['MaintenanceFax'],
      });
    } else {
      this.submitFail = true
    }
    this.changeDetectorRef.detectChanges();
    this.globalServices.isLoaderEnabled = false;
  }
  getSupplierBanksData(supplierBanks): any {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierBanks'];
    supplierBanks.forEach((key) => {
      // let BankName = new FormControl({ value: key.BankName, disabled: this.isFormArrayControlsDisabled });
      // BankName.setValidators([Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
      // BankName.updateValueAndValidity();
      let BankId = new FormControl({ value: key.BankId, disabled: this.isFormArrayControlsDisabled });
      BankId.setValidators([Validators.required]);
      BankId.updateValueAndValidity();

      let BankBranch = new FormControl({ value: key.BankBranch, disabled: this.isFormArrayControlsDisabled });
      BankBranch.setValidators([Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
      BankBranch.updateValueAndValidity();

      let AccountNumber = new FormControl({ value: key.AccountNumber, disabled: this.isFormArrayControlsDisabled });
      AccountNumber.setValidators([Validators.required, Validators.pattern(this.numberRegex)]);//Validators.minLength(10), Validators.maxLength(16),
      AccountNumber.updateValueAndValidity();

      let formGroup = new FormGroup({ BankId, BankBranch, AccountNumber });
      control.push(formGroup);

    });
    return control;
  }
  getSupplierSpecialitiesData(supplierSpecialities): any {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierSpecialities'];
    supplierSpecialities.forEach((key) => {
      //Test Changed
      let Id = new FormControl({ value: key.Id, disabled: true });
      let nameEN = this.categories.filter(s => s.Id == key.Speciality.CategoryId).map(e => e.NameEN)
      let nameAR = this.categories.filter(s => s.Id == key.Speciality.CategoryId).map(e => e.NameAR)
      this.selectedCats.push([
        {Id: key.Speciality.CategoryId, NameEN: nameEN[0], NameAR: nameAR[0]}
      ]);
      // let CategoryId = new FormControl({ value: key.Speciality.CategoryId, disabled: true });
      let CategoryId = new FormControl({ disabled: true });
      CategoryId.setValidators([Validators.required]);
      CategoryId.updateValueAndValidity();

      let SpecialityId = new FormControl({ value: key.SpecialityId, disabled: true && !(this.formMode == FormMode.AdminEdit) || key.Status == 0 });
      SpecialityId.setValidators([Validators.required]);
      SpecialityId.updateValueAndValidity();

      let CategoryContactPerson = new FormControl({ value: key.ContactPerson, disabled: this.isFormArrayControlsDisabled });
      CategoryContactPerson.setValidators([Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
      CategoryContactPerson.updateValueAndValidity();

      let CategoryEmail = new FormControl({ value: key.Email, disabled: this.isFormArrayControlsDisabled });
      CategoryEmail.setValidators([Validators.maxLength(100), Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]);//Validators.required,
      CategoryEmail.updateValueAndValidity();

      let CategoryFax = new FormControl({ value: key.Fax, disabled: this.isFormArrayControlsDisabled });
      CategoryFax.setValidators([Validators.maxLength(50), Validators.pattern(this.numberRegex)]);//Validators.required,
      CategoryFax.updateValueAndValidity();

      let CategoryMobile = new FormControl({ value: key.Mobile, disabled: this.isFormArrayControlsDisabled });
      CategoryMobile.setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(this.numberRegex)]);
      CategoryMobile.updateValueAndValidity();

      // let CategoryAddress = new FormControl({ value: key.Address, disabled: this.isFormArrayControlsDisabled });
      // CategoryAddress.setValidators([Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]);
      // CategoryAddress.updateValueAndValidity();

      let CategoryExperience = new FormControl({ value: key.ExperienceCopyURL, disabled: this.isFormArrayControlsDisabled });
      CategoryExperience.setValidators([Validators.required]);
      CategoryExperience.updateValueAndValidity();

      let CategoryExperienceCopyURL = new FormControl({ value: key.ExperienceCopyURL, disabled: this.isFormArrayControlsDisabled });


      let CategoryExperienceCopyName = new FormControl({ value: key.ExperienceCopyName, disabled: this.isFormArrayControlsDisabled });

      let Status = new FormControl({ value: key.Status, disabled: this.isFormArrayControlsDisabled });

      let formGroup = new FormGroup({
        // Test Changed
        Id,
        CategoryId,
        SpecialityId,
        CategoryContactPerson,
        CategoryEmail,
        CategoryFax,
        CategoryMobile,
        // CategoryAddress,
        CategoryExperience,
        CategoryExperienceCopyURL,
        CategoryExperienceCopyName,
        Status

      });
      control.push(formGroup);



    });
    return control;
  }
  getSupplierPartnershipsData(supplierPartnerships): any {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierPartnerships'];
    supplierPartnerships.forEach((key) => {

      let PartnerName = new FormControl({ value: key.PartnerName, disabled: this.isFormArrayControlsDisabled && !(this.formMode == FormMode.AdminEdit) });
      PartnerName.setValidators([Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
      PartnerName.updateValueAndValidity();

      let NationalityId = new FormControl({ value: key.NationalityId, disabled: this.isFormArrayControlsDisabled });
      NationalityId.setValidators([Validators.required]);
      NationalityId.updateValueAndValidity();

      let RegisterationDate = new FormControl({ value: key.RegisterationDate, disabled: this.isFormArrayControlsDisabled });
      RegisterationDate.setValidators([Validators.required, CustomValidators.pastDateValidator()]);
      RegisterationDate.updateValueAndValidity();

      let PartnerWebsiteURL = new FormControl({ value: key.PartnerWebsiteURL, disabled: this.isFormArrayControlsDisabled });
      PartnerWebsiteURL.setValidators([Validators.pattern(this.websiteRegex), Validators.maxLength(100)]);//[Validators.required]
      PartnerWebsiteURL.updateValueAndValidity();

      let SelectedSupplierPartnershipCategories = new FormControl({
        value: key.SupplierPartnershipCategories.map(function (currItem) {
          return {
            Id: currItem.Category.Id,
            NameAR: currItem.Category.NameAR,
            NameEN: currItem.Category.NameEN
          }
        }), disabled: this.isFormArrayControlsDisabled
      });
      SelectedSupplierPartnershipCategories.setValidators([Validators.required]);
      SelectedSupplierPartnershipCategories.updateValueAndValidity();

      let PartnershipAttachment = new FormControl({ value: key.SupplierCommercialAgencyCopyURL, disabled: this.isFormArrayControlsDisabled });
      PartnershipAttachment.setValidators([Validators.required]);
      PartnershipAttachment.updateValueAndValidity();

      let SupplierCommercialAgencyCopyURL = new FormControl({ value: key.SupplierCommercialAgencyCopyURL, disabled: this.isFormArrayControlsDisabled });

      let SupplierCommercialAgencyCopyName = new FormControl({ value: key.SupplierCommercialAgencyCopyName, disabled: this.isFormArrayControlsDisabled });

      let formGroup = new FormGroup({
        PartnerName,
        NationalityId,
        RegisterationDate,
        PartnerWebsiteURL,
        SelectedSupplierPartnershipCategories,
        PartnershipAttachment,
        SupplierCommercialAgencyCopyURL,
        SupplierCommercialAgencyCopyName
      });
      control.push(formGroup);



    });
    return control;
  }

  getSupplierCertificatesData(supplierCertificates): any {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierCertificates'];
    supplierCertificates.forEach((key, index) => {
      // let Id = new FormControl({ value: key.Id, disabled: true });
      let CertificateTypeId = new FormControl({ value: key.CertificateType, disabled: this.isFormArrayControlsDisabled });
      CertificateTypeId.setValidators([Validators.required]);
      CertificateTypeId.updateValueAndValidity();
      let CertificateTypeOther = new FormControl({ value: key.CertificateTypeOther, disabled: this.isFormArrayControlsDisabled });
      if (CertificateTypeId.value == this.supplierCertificateTypes['Other Certificates']){
        this.showCertificateTypeOther.push(index);
        CertificateTypeOther.setValidators([Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
        CertificateTypeOther.updateValueAndValidity();
      } else {
        CertificateTypeOther.setValidators([Validators.maxLength(100), CustomValidators.textSpaceValidator()]);
        CertificateTypeOther.updateValueAndValidity();
      }
      let Certificate = new FormControl({ value: key.URL, disabled: this.isFormArrayControlsDisabled });
      Certificate.setValidators([Validators.required]);
      Certificate.updateValueAndValidity();
      let CertificateCopyURL = new FormControl({ value: key.URL, disabled: this.isFormArrayControlsDisabled });
      let CertificateCopyName = new FormControl({ value: key.DocumentName, disabled: this.isFormArrayControlsDisabled });
      let formGroup = new FormGroup({
        CertificateTypeId,
        CertificateTypeOther,
        Certificate,
        CertificateCopyURL,
        CertificateCopyName
      });
      control.push(formGroup);
    });
    return control;
  }
  get getFormControls() {
    return this.supplierRegistrationForm.controls;
  }
  get getBasicSupplierInfoTabControls() {
    this.checkSupplierFormValid()
    return this.supplierRegistrationForm.get('BasicSupplierInfoTab')['controls'];

  }
  get getContactInfoTabControls() {
    return this.supplierRegistrationForm.get('ContactInfoTab')['controls'];
  }
  get getSupplierMaintenanceTabControls() {
    return this.supplierRegistrationForm.get('SupplierMaintenanceTab')['controls'];
  }
  get getSupplierCertificateTabControls() {
    return this.supplierRegistrationForm.get('SupplierCertificates')['controls'];
  }

  onChangeAverageAnnualTurnover(event) {
    if (event != null) {
      let AverageAnnualTurnoverEvent = event.target.value;
      const AverageAnnualTurnover = this.getBasicSupplierInfoTabControls['AverageAnnualTurnover'];
      const AverageAnnualTurnoverCurrencyId = this.getBasicSupplierInfoTabControls['AverageAnnualTurnoverCurrencyId'];
      if (AverageAnnualTurnoverEvent) {
        if (AverageAnnualTurnover != null && AverageAnnualTurnover.errors != null) {
          if (AverageAnnualTurnover.errors.pattern) {
            AverageAnnualTurnoverCurrencyId.disable();
            AverageAnnualTurnoverCurrencyId.setValue('');
            AverageAnnualTurnoverCurrencyId.clearValidators();
            AverageAnnualTurnoverCurrencyId.updateValueAndValidity();
            return false;
          }
        } else {
          AverageAnnualTurnoverCurrencyId.enable();
          AverageAnnualTurnoverCurrencyId.setValidators([Validators.required]);
          AverageAnnualTurnoverCurrencyId.updateValueAndValidity();
          return true;
        }
      } else {
        AverageAnnualTurnoverCurrencyId.disable();
        AverageAnnualTurnoverCurrencyId.setValue('');
        AverageAnnualTurnoverCurrencyId.clearValidators();
        AverageAnnualTurnoverCurrencyId.updateValueAndValidity();
        return false;
      }
    }
  };

  //#endregion
  //#region FormArray Functions
  //#region Banks Form Array Functions
  getSupplierBanksValidity() {
    let controls = this.supplierRegistrationForm.get('SupplierBanks') as FormArray;
    return controls.valid;
  }
  AddSupplierBank() {

    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierBanks'];
    control.push(new FormGroup({
      // UserId: new FormControl(''),
      // BankName: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
      BankId: new FormControl('', [Validators.required]),
      BankBranch: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
      AccountNumber: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)])//Validators.minLength(10), Validators.maxLength(16),
    }));
  }
  get supplierBanks() {
    // return this.supplierRegistrationForm.get('SupplierBanks') as FormArray;
    return this.getFormControls.SupplierBanks as FormArray;
  }
  DeleteSupplierBank(index: number) {
    this.supplierBanks.removeAt(index);
  }

  AddSupplierCertificate() {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierCertificates'];
    control.push(new FormGroup({
      CertificateTypeId: new FormControl('', [Validators.required]),
      CertificateTypeOther: new FormControl('', [Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
      Certificate: new FormControl('', [Validators.required]),
      CertificateCopyURL: new FormControl(''),
      CertificateCopyName: new FormControl('')
    }));
  }
  get supplierCertificates() {
    return this.getFormControls.SupplierCertificates as FormArray;
  }

  DeleteSupplierCertificate(index: number) {
    this.supplierCertificates.removeAt(index);
  }

  OnCertificateTypeChange(event,index) {
    const CertificateTypeOther = this.supplierRegistrationForm['controls']['SupplierCertificates']['controls'][index]['controls']['CertificateTypeOther']
    if (event.target.value == this.supplierCertificateTypes['Other Certificates']) {
      this.showCertificateTypeOther.push(index);
      CertificateTypeOther.setValidators([Validators.required]);
      CertificateTypeOther.updateValueAndValidity();
    } else {
      this.showCertificateTypeOther = this.showCertificateTypeOther.filter(c => c !== index);
      CertificateTypeOther.clearValidators();
      CertificateTypeOther.setValue('');
      CertificateTypeOther.updateValueAndValidity();
    }
  }



  //#endregion
  //#region Supplier Specialities Form Array Functions
  AddSupplierSpeciality(index: number, IsLast: boolean) {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierSpecialities'];
    control.push(new FormGroup({
      //Test Changed
      Id: new FormControl(''),
      CategoryId: new FormControl('', [Validators.required]),
      SpecialityId: new FormControl('', [Validators.required]),
      CategoryContactPerson: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
      CategoryEmail: new FormControl('', [Validators.maxLength(100), Validators.pattern(this.emailRegex), CustomValidators.textSpaceValidator()]),//Validators.required,
      CategoryFax: new FormControl('', [Validators.maxLength(50), Validators.pattern(this.numberRegex)]),//Validators.required,
      CategoryMobile: new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern(this.numberRegex)]),
      // CategoryAddress: new FormControl('', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]),
      CategoryExperience: new FormControl('', [Validators.required]),
      CategoryExperienceCopyURL: new FormControl(''),//, [Validators.required]),
      CategoryExperienceCopyName: new FormControl(''),//, [Validators.required])
      Status: new FormControl('')
    }));
  }
  get supplierSpecialities() {
    // return this.supplierRegistrationForm.get('SupplierSpecialities') as FormArray;
    return this.getFormControls.SupplierSpecialities as FormArray;
  }

  DeleteSupplierSpeciality(index: number) {
    if (this.formMode == FormMode.Add) {
      this.supplierSpecialities.removeAt(index);
    } else {
      // User Edit Mode
      if (this.supplierSpecialities['controls'][index]['controls']['CategoryId'].value != "") {
        // Found in accepted categories
        if (this.supplierSpecialityFromDB[index] !== undefined && this.supplierSpecialityFromDB.length > 1) {
          // Not last one accepted [Can be deleted]
          this.deletedSupplierSpecialities.push(this.supplierSpecialityFromDB[index]);
          this.supplierSpecialityFromDB.splice(index, 1);
          this.supplierSpecialities.removeAt(index);
        } else {
          // Last one accepted [Can't be deleted]
          this.islastCategoryAccepted = true;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
          //alert("Last category accepted can't be deleted");
        }
      } else {
        // Not Found in accepted categories [Can be deleted]
        this.supplierSpecialities.removeAt(index);
      }
    }
  }
  //#endregion
  //#region Supplier Partnerships Form Array Functions
  AddSupplierPartnership() {
    let control = <FormArray>this.supplierRegistrationForm.controls['SupplierPartnerships'];
    control.push(new FormGroup({
      PartnerName: new FormControl('', [Validators.required, Validators.maxLength(100), CustomValidators.textSpaceValidator()]),
      NationalityId: new FormControl('', [Validators.required]),
      RegisterationDate: new FormControl('', [Validators.required, CustomValidators.pastDateValidator()]),
      PartnerWebsiteURL: new FormControl('', [Validators.pattern(this.websiteRegex), Validators.maxLength(100)]),//, [Validators.required]),
      SelectedSupplierPartnershipCategories: new FormControl('', Validators.required),
      PartnershipAttachment: new FormControl('', [Validators.required]),
      SupplierCommercialAgencyCopyURL: new FormControl(''),
      SupplierCommercialAgencyCopyName: new FormControl('')//,
    }));
  }
  get supplierPartnerships() {
    //  return this.supplierRegistrationForm.get('SupplierPartnerships') as FormArray;
    return this.getFormControls.SupplierPartnerships as FormArray;
  }
  DeleteSupplierPartnership(index: number) {

    this.supplierPartnerships.removeAt(index);
  }
  //#endregion
  //#endregion
  //#region Uploader Functions
  async AddAttachmentFile(event, currFormControl, docName, progressVariableName, index?, isBasicInfo?: boolean, isCategory?: boolean, isPartner?: boolean, attachmentType?: AttachmentType, key?: string) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
    }
    const file = event.target.files[0];
    this.uploadedFileName = file.name;
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ETenderUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ 'invalid': true });
        } else if (event instanceof HttpResponse) {
          currFormControl.setErrors(null);
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          if (isBasicInfo) {
            //Basic Supplier Attachments
            const attachment = new Attachment();
            attachment.URL = Url;
            attachment.DocumentName = docName;
            attachment.AttachmentTypeId = attachmentType;
            if (this.formMode == FormMode.Edit || this.formMode == FormMode.AdminEdit) {
              attachment.BaseRequestId = this.baseRequestDTO.Id;
            }
            this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(h => h.AttachmentTypeId !== attachmentType);
            this.supplierRegistrationFormAttachments.push(attachment);
          } else if (isCategory) {
            this.supplierRegistrationForm['controls']['SupplierSpecialities']['controls'][index]['controls']['CategoryExperienceCopyURL'].setValue(Url);
            this.supplierRegistrationForm['controls']['SupplierSpecialities']['controls'][index]['controls']['CategoryExperienceCopyName'].setValue(this.uploadedFileName);
          } else if (isPartner) {
            this.supplierRegistrationForm['controls']['SupplierPartnerships']['controls'][index]['controls']['SupplierCommercialAgencyCopyURL'].setValue(Url);
            this.supplierRegistrationForm['controls']['SupplierPartnerships']['controls'][index]['controls']['SupplierCommercialAgencyCopyName'].setValue(this.uploadedFileName);

          }
        }
      }
    );
  }

  async AddCertificateFile(event, currFormControl, docName, progressVariableName, index?, key?: string) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
    }
    const file = event.target.files[0];
    this.uploadedFileName = file.name;
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ETenderUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ 'invalid': true });
        } else if (event instanceof HttpResponse) {
          currFormControl.setErrors(null);
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          this.supplierRegistrationForm['controls']['SupplierCertificates']['controls'][index]['controls']['CertificateCopyURL'].setValue(Url);
          this.supplierRegistrationForm['controls']['SupplierCertificates']['controls'][index]['controls']['CertificateCopyName'].setValue(this.uploadedFileName);
        }
      }
    );
  }

  get getAttachmentType() {
    return AttachmentType;
  }
  //#endregion
  //#region Drop Down Lists Functions
  loadAllLookUps() {
    this.globalServices.isLoaderEnabled = true;
    this.multiDropDownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.currentLanguage == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.currentLanguage == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.currentLanguage == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
    this.multiDropDownSettingsCats = {
      singleSelection: true,
      idField: 'Id',
      textField: this.currentLanguage == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.currentLanguage == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.currentLanguage == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.lookupService.getAllSupplierRegistrationLookups().subscribe(
      (data: ResponseObject) => { this.supplierRegistrationLookups = data.Data as SupplierRegistrationLookups; },
      () => this.submitFail = true,
      () => this.loadAllLookUpsCompleted()
    );
  }

  loadAllLookUpsCompleted() {
    this.supplierNatures = this.supplierRegistrationLookups.SupplierNatures;
    this.supplierTypes = this.supplierRegistrationLookups.SupplierTypes;
    this.contractorCategories = this.supplierRegistrationLookups.ContractorCategories;
    this.contractorClassifications = this.supplierRegistrationLookups.ContractorClassifications;
    this.specialities = this.supplierRegistrationLookups.Specialities;
    this.supplierAccountStatuses = this.supplierRegistrationLookups.SupplierAccountStatuses;
    this.governorates = this.supplierRegistrationLookups.Governorates;
    this.currencies = this.supplierRegistrationLookups.Currencies;
    this.categories = this.supplierRegistrationLookups.Categories;
    this.nationalities = this.supplierRegistrationLookups.Nationalities;
    this.banks = this.supplierRegistrationLookups.Banks;
    if (!this.supplierId) {
      this.globalServices.isLoaderEnabled = false;
    }
  }

  createSelectedSupplierPartnershipCategoriesIds(index) {
    if (this.supplierRegistrationForm.valid && this.supplierRegistrationForm.controls.SupplierPartnerships.value[index].SelectedSupplierPartnershipCategories) {
      this.selectedSupplierPartnershipCategoriesIds = this.supplierRegistrationForm.controls.SupplierPartnerships.value[index].SelectedSupplierPartnershipCategories.map(function (currItem) {
        return currItem.Id;
      });

      //this.getFormControls['SupplierPartnerships']['controls'] SelectedSupplierPartnershipCategories

      this.allSelectedSupplierPartnershipCategoriesIds.push(this.selectedSupplierPartnershipCategoriesIds);

      let control = <FormArray>this.supplierRegistrationForm.controls['SupplierPartnerships'];
      control.controls[index]['controls']["SelectedSupplierPartnershipCategoriesIds"].setValue(this.selectedSupplierPartnershipCategoriesIds);

      //control.controls[index]["controls"]["SelectedSupplierPartnershipCategories"].setValue(this.selectedSupplierPartnershipCategoriesIds);
      //control[index].controls.SelectedSupplierPartnershipCategoriesIds.setValue(selectedSupplierPartnershipCategoriesIds);
      // this.supplierRegistrationForm['SupplierPartnerships'].controls[index].controls['SelectedSupplierPartnershipCategoriesIds'].setValue(selectedSupplierPartnershipCategoriesIds);
    }
  }

  onSupplierTypeChange(event) {
    //Supplier Type != industrial
    const commercialRecordNumber = this.getBasicSupplierInfoTabControls['CommercialRecordNumber'];
    const commericalRecordCopy = this.getBasicSupplierInfoTabControls['CommericalRecordCopy'];
    const commercialRecordExpiryDate = this.getBasicSupplierInfoTabControls['CommercialRecordExpiryDate'];
    //Supplier Type == industrial
    const industrialRegistrationNumber = this.getBasicSupplierInfoTabControls['IndustrialRegistrationNumber'];

    //Supplier Type == Contractor
    const constructionNumber = this.getBasicSupplierInfoTabControls['ConstructionNumber'];
    const contractorCategoryId = this.getBasicSupplierInfoTabControls['ContractorCategoryId'];
    const contructorCategoryCopy = this.getBasicSupplierInfoTabControls['ContructorCategoryCopy'];
    const contractorClassificationId = this.getBasicSupplierInfoTabControls['ContractorClassificationId'];
    const contructorClassificationCopy = this.getBasicSupplierInfoTabControls['ContructorClassificationCopy'];
    if (event != null) {
      if (event.target.value == 2) {
        industrialRegistrationNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        industrialRegistrationNumber.updateValueAndValidity();
        commercialRecordNumber.clearValidators();
        commercialRecordNumber.setValue('');
        commercialRecordNumber.updateValueAndValidity();
        commericalRecordCopy.clearValidators();
        commericalRecordCopy.setValue('');
        this.commericalRecordCopyProgress = 0;
        commericalRecordCopy.updateValueAndValidity();
        commercialRecordExpiryDate.clearValidators();
        commercialRecordExpiryDate.setValue('');
        commercialRecordExpiryDate.updateValueAndValidity();
      }
      else {
        industrialRegistrationNumber.clearValidators();
        industrialRegistrationNumber.setValue('');
        industrialRegistrationNumber.updateValueAndValidity();
        commercialRecordNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        commercialRecordNumber.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.commericalRecordCopyAttachment == null) {
          commericalRecordCopy.setValidators([Validators.required]);
        }
        commericalRecordCopy.updateValueAndValidity();
        commercialRecordExpiryDate.setValidators([Validators.required, CustomValidators.dateValidator()]);
        commercialRecordExpiryDate.updateValueAndValidity();
      }
      if (event.target.value == 4) {
        constructionNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        constructionNumber.updateValueAndValidity();
        contractorCategoryId.setValidators([Validators.required]);
        contractorCategoryId.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.contructorCategoryCopyAttachment == null) {
          contructorCategoryCopy.setValidators([Validators.required]);
        }
        contructorCategoryCopy.updateValueAndValidity();
        contractorClassificationId.setValidators([Validators.required]);
        contractorClassificationId.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.contructorClassificationCopyAttachment == null) {
          contructorClassificationCopy.setValidators([Validators.required]);
        }
        contructorClassificationCopy.updateValueAndValidity();
      }
      else {
        constructionNumber.clearValidators();
        constructionNumber.setValue('');
        constructionNumber.updateValueAndValidity();
        contractorCategoryId.clearValidators();
        contractorCategoryId.setValue('');
        contractorCategoryId.updateValueAndValidity();
        contructorCategoryCopy.clearValidators();
        contructorCategoryCopy.setValue('');
        this.contructorCategoryCopyProgress = 0;
        contructorCategoryCopy.updateValueAndValidity();
        contractorClassificationId.clearValidators();
        contractorClassificationId.setValue('');
        contractorClassificationId.updateValueAndValidity();
        contructorClassificationCopy.clearValidators();
        contructorClassificationCopy.setValue('');
        this.contructorClassificationCopyProgress = 0;
        contructorClassificationCopy.updateValueAndValidity();
      }
    } else if (this.supplierTypeId) {
      if (this.supplierTypeId == 2) {
        industrialRegistrationNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        industrialRegistrationNumber.updateValueAndValidity();
        commercialRecordNumber.clearValidators();
        commercialRecordNumber.setValue('');
        commercialRecordNumber.updateValueAndValidity();
        commericalRecordCopy.clearValidators();
        commericalRecordCopy.setValue('');
        this.commericalRecordCopyProgress = 0;
        commericalRecordCopy.updateValueAndValidity();
        commercialRecordExpiryDate.clearValidators();
        commercialRecordExpiryDate.setValue('');
        commercialRecordExpiryDate.updateValueAndValidity();
      }
      else {
        industrialRegistrationNumber.clearValidators();
        industrialRegistrationNumber.setValue('');
        industrialRegistrationNumber.updateValueAndValidity();
        commercialRecordNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        commercialRecordNumber.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.commericalRecordCopyAttachment == null) {
          commericalRecordCopy.setValidators([Validators.required]);
        }
        commericalRecordCopy.updateValueAndValidity();
        commercialRecordExpiryDate.setValidators([Validators.required, CustomValidators.dateValidator()]);
        commercialRecordExpiryDate.updateValueAndValidity();
      }
      if (this.supplierTypeId == 4) {
        constructionNumber.setValidators([Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
        constructionNumber.updateValueAndValidity();
        contractorCategoryId.setValidators([Validators.required]);
        contractorCategoryId.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.contructorCategoryCopyAttachment == null) {
          contructorCategoryCopy.setValidators([Validators.required]);
        }
        contructorCategoryCopy.updateValueAndValidity();
        contractorClassificationId.setValidators([Validators.required]);
        contractorClassificationId.updateValueAndValidity();
        if (this.formMode == FormMode.Add || this.contructorClassificationCopyAttachment == null) {
          contructorClassificationCopy.setValidators([Validators.required]);
        }
        contructorClassificationCopy.updateValueAndValidity();
      }
      else {
        constructionNumber.clearValidators();
        constructionNumber.setValue('');
        constructionNumber.updateValueAndValidity();
        contractorCategoryId.clearValidators();
        contractorCategoryId.setValue('');
        contractorCategoryId.updateValueAndValidity();
        contructorCategoryCopy.clearValidators();
        contructorCategoryCopy.setValue('');
        this.contructorCategoryCopyProgress = 0;
        contructorCategoryCopy.updateValueAndValidity();
        contractorClassificationId.clearValidators();
        contractorClassificationId.setValue('');
        contractorClassificationId.updateValueAndValidity();
        contructorClassificationCopy.clearValidators();
        contructorClassificationCopy.setValue('');
        this.contructorClassificationCopyProgress = 0;
        contructorClassificationCopy.updateValueAndValidity();
      }
    }
  }

  onSupplierIsChange(event) {
    this.changeDetectorRef.detectChanges();
    if (event.target.value == "false") {
      //FOREIGN
      this.isLocalSupplier.emit(false);
      this.showUnderconstructionMessage = true;
      this.changeDetectorRef.detectChanges();
    }
    else if (event.target.value == "true") {
      //LOCAL
      this.isLocalSupplier.emit(true);
      this.showUnderconstructionMessage = false;
      this.changeDetectorRef.detectChanges();

    } else {
      this.isLocalSupplier.emit(false);
    }
  }

  getCriteria(index, categoryId) {
    if (categoryId != undefined && categoryId != '' && this.formMode != FormMode.Readonly && this.specialities != null) {
      return this.specialities.filter(s => s.CategoryId == categoryId[0].Id);
    }else if ((categoryId == '' || categoryId == undefined) && this.formMode != FormMode.Readonly && this.specialities != null) {
      return [];
    }
    else {
      return this.specialities;
    }
  }

  onCategoryChange(event, index) {
    // if (event.target.value == "") {
      if (event && event.Id == "") {
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].setValue('');
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].updateValueAndValidity();
    }
  }
  onCategoryDeselect(event,index){
    if (event) {
      delete this.selectedCats[index];
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['CategoryId'].setValue('');
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['CategoryId'].updateValueAndValidity();
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].setValue('');
      this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].updateValueAndValidity();
    }
  }
  onSpecialtyChnage(event, index) {
    this.alertService.clear();
    if (event.target.value != "") {
      let selectedSpecialtyIndex = event.target.selectedIndex;
      let selectedSpecialtyText = event.target[selectedSpecialtyIndex].innerText;
      this.slectedSpeciatilty =
        this.supplierRegistrationForm.controls['SupplierSpecialities']['controls']
          .filter(s => s["controls"]['SpecialityId'].value == event.target.value);
      if (this.slectedSpeciatilty.length > 1) {
        this.alertService.error(this.repeatedSpecialityErrorMessage);
        this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].setValue('');
        this.supplierRegistrationForm.controls['SupplierSpecialities']['controls'][index]["controls"]['SpecialityId'].updateValueAndValidity();
        this.slectedSpeciatilty = new Array();
        window.scrollTo(0, 0);
      }
    }
    // let control = <FormArray>this.supplierRegistrationForm.controls['SupplierSpecialities'];
    // let currentSelectedCategoryId = control.controls[index]['controls']["CategoryId"].value;
    // let currentSelectedSpecialityId = control.controls[index]['controls']["SpecialityId"].value;
  }
  //#endregion
  //#region Date Picker Functions
  get getTodayDate() {
    return new Date();
  }
  //#endregion
  //#region Control Value Accessor Functions
  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.supplierRegistrationForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.supplierRegistrationForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.supplierRegistrationForm.disable() : this.supplierRegistrationForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this.supplierRegistrationForm.valid ? null : this.supplierRegistrationForm.controls;
  }

  //#endregion
  //#region Tabs Functions
  checkSupplierFormValid() {
    if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
      this.supplierRegistrationForm.controls['SupplierBanks'].invalid ||
      this.supplierRegistrationForm.controls['ContactInfoTab'].invalid ||
      this.supplierRegistrationForm.controls['SupplierSpecialities'].invalid ||
      this.supplierRegistrationForm.controls['SupplierPartnerships'].invalid ||
      this.supplierRegistrationForm.controls['SupplierMaintenanceTab'].invalid || 
      this.supplierRegistrationForm.controls['SupplierCertificates'].invalid
    ) {
      this.isSupplierFormValid.emit(false);
    } else {
      this.isSupplierFormValid.emit(true);
    }
    // this.changeDetectorRef.detectChanges();
  }

  // get supplierBasicInfo() {
  //       return this.getFormControls.BasicSupplierInfoTab as FormArray;
  // }




  selectTab(tabId: number) {
    switch (tabId) {
      case 1:
        if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid) {
          // if (this.supplierBasicInfo.invalid) {
          this.isTabOneSubmitted = true;
          this.navigaeToFirstInvalid(this.basicSupplierInfoTab);
          return;
        } else {
          this.isTabOneSubmitted = false;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
        }
        break;
      case 2:
        if (this.supplierBanks.invalid) {
          this.isTabTwoSubmitted = true;
          this.navigaeToFirstInvalid(this.supplierBanksTab);
          return;
        } else {
          this.isTabOneSubmitted = false;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
        }
        break;
      case 3:
        if (this.supplierRegistrationForm.controls['ContactInfoTab'].invalid) {
          this.navigaeToFirstInvalid(this.contactInfoTab);

          this.isTabThreeSubmitted = true;
          return;
        } else {
          this.isTabOneSubmitted = false;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
        }
        break;
      case 4:
        if (this.supplierSpecialities.invalid) {
          this.navigaeToFirstInvalid(this.supplierSpecialitiesTab);

          this.isTabFourSubmitted = true;
          return;
        } else {
          this.isTabOneSubmitted = false;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
        }
        break;
      case 5:
        if (this.supplierPartnerships.invalid) {
          this.navigaeToFirstInvalid(this.supplierPartnershipsTab);

          this.isTabFiveSubmitted = true;
          return;
        } else {
          this.isTabOneSubmitted = false;
          const el = document.getElementsByClassName('section-title');
          el[0].scrollIntoView({ behavior: 'smooth' });
        }
        case 6:
          if (this.getSupplierMaintenanceTabControls.invalid) {
            this.navigaeToFirstInvalid(this.getSupplierMaintenanceTabControls);
            this.isTabSixSubmitted = true;
            return;
          } else {
            this.isTabOneSubmitted = false;
            const el = document.getElementsByClassName('section-title');
            el[0].scrollIntoView({ behavior: 'smooth' });
          }
        break;
      default:
        break;
    }
    this.supplierTabs.tabs[tabId].disabled = false;
    this.supplierTabs.tabs[tabId].active = true;
  }
  navigaeToFirstInvalid(CurrentTabElementRef: ElementRef) {
    const invalidControls = CurrentTabElementRef.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length > 0) {
      for (let index = 0; index < invalidControls.length; index++) {
        const element = invalidControls[index];
        if (element.localName != "div") {
          element.focus();
          return;
        }
      }
    }
  }
  navigateToTab(tabId: number) {
    this.supplierTabs.tabs[tabId].disabled = false;
    this.supplierTabs.tabs[tabId].active = true;
  }
  get disableTabs() {
    // return false;
    if (this.supplierTabs) {
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid) {
        // if (false) {
        this.supplierTabs.tabs[1].disabled = true;
        this.supplierTabs.tabs[2].disabled = true;
        this.supplierTabs.tabs[3].disabled = true;
        this.supplierTabs.tabs[4].disabled = true;
        this.supplierTabs.tabs[5].disabled = true;
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[1].disabled = false;
      }
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
        this.supplierBanks.invalid) {
        // if (false) {
        this.supplierTabs.tabs[2].disabled = true;
        this.supplierTabs.tabs[3].disabled = true;
        this.supplierTabs.tabs[4].disabled = true;
        this.supplierTabs.tabs[5].disabled = true;
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[2].disabled = false;
      }
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
        this.supplierBanks.invalid ||
        this.supplierRegistrationForm.controls['ContactInfoTab'].invalid) {
        // if (false) {
        this.supplierTabs.tabs[3].disabled = true;
        this.supplierTabs.tabs[4].disabled = true;
        this.supplierTabs.tabs[5].disabled = true;
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[3].disabled = false;
      }
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
        this.supplierBanks.invalid ||
        this.supplierRegistrationForm.controls['ContactInfoTab'].invalid ||
        this.supplierSpecialities.invalid) {
        // if (false) {
        this.supplierTabs.tabs[4].disabled = true;
        this.supplierTabs.tabs[5].disabled = true;
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[4].disabled = false;
      }
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
        this.supplierBanks.invalid ||
        this.supplierRegistrationForm.controls['ContactInfoTab'].invalid ||
        this.supplierSpecialities.invalid ||
        this.supplierPartnerships.invalid) {
        // if (false) {
        this.supplierTabs.tabs[5].disabled = true;
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[5].disabled = false;
      }
      if (this.supplierRegistrationForm.controls['BasicSupplierInfoTab'].invalid ||
        this.supplierBanks.invalid ||
        this.supplierRegistrationForm.controls['ContactInfoTab'].invalid ||
        this.supplierSpecialities.invalid ||
        this.supplierPartnerships.invalid ||
        this.supplierRegistrationForm.controls['SupplierMaintenanceTab'].invalid) {
        // if (false) {
        this.supplierTabs.tabs[6].disabled = true;
        return true;
      } else {
        this.supplierTabs.tabs[6].disabled = false;
      }
    }
  }
  //#endregion
  //#region Edit Supplier Functions
  checkFormControlsValid() {
    let isValid: boolean = true;
    const controls = this.getFormControls;
    for (const name in controls) {
      if (controls[name].invalid) {
        // invalid.push(name);
        isValid = false;
      }
    }
    return isValid;
    // if (this.formMode == FormMode.Edit || this.formMode == FormMode.AdminEdit) {
    //   return true;
    // }
    // else {
    //   return false;
    // }
  }
  editSupplier() {
    this.globalServices.isLoaderEnabled = true;

    if (this.formMode == FormMode.AdminEdit) {
      this.UpdatedSupplier.IsAdminEditMode = true;
    } else {
      this.UpdatedSupplier.IsAdminEditMode = false;
    }
    //Bassic.Info

    this.UpdatedSupplier.UserId = this.supplierId;
    this.UpdatedSupplier.IsLocalSupplier = this.supplierRegistrationForm.controls.IsLocalSupplier.value;
    this.UpdatedSupplier.SupplierNatureId = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].SupplierNatureId.value;
    this.UpdatedSupplier.SupplierTypeId = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].SupplierTypeId.value;
    this.UpdatedSupplier.CompanyName = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CompanyName.value;
    this.UpdatedSupplier.CommercialName = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CommercialName.value;
    this.UpdatedSupplier.CommercialRecordNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CommercialRecordNumber.value;
    this.UpdatedSupplier.IndustrialRegistrationNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].IndustrialRegistrationNumber.value;
    this.UpdatedSupplier.TaxRecordNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxRecordNumber.value;
    // this.UpdatedSupplier.TaxCardNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxCardNumber.value;
    this.UpdatedSupplier.TaxAuthority = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxAuthority.value;
    this.UpdatedSupplier.VATNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].VATNumber.value;
    this.UpdatedSupplier.ActivityLegalRecordRegistrationNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ActivityLegalRecordRegistrationNumber.value;
    this.UpdatedSupplier.PaidCapital = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].PaidCapital.value;
    this.UpdatedSupplier.AverageAnnualTurnover = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].AverageAnnualTurnover.value;
    this.UpdatedSupplier.AverageAnnualTurnoverCurrencyId = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].AverageAnnualTurnoverCurrencyId.value;


    // Data Issue
    // this.UpdatedSupplier.CommercialRecordExpiryDate = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CommercialRecordExpiryDate.value;
    // if (this.supplierRegistrationForm.value.BasicSupplierInfoTab.CommercialRecordExpiryDate) {
    if (this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CommercialRecordExpiryDate.value) {
      var selectedCommercialRecordExpiryDate = new Date(this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CommercialRecordExpiryDate.value).toLocaleDateString('en-US');
      this.UpdatedSupplier.CommercialRecordExpiryDate = new Date(Date.parse(selectedCommercialRecordExpiryDate + this.fixedTimeGMT));
    }

    // this.UpdatedSupplier.TaxCardExpiryDate = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxCardExpiryDate.value;
    // if (this.supplierRegistrationForm.value.BasicSupplierInfoTab.TaxCardExpiryDate) {
    if (this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxCardExpiryDate.value) {
      var selectedTaxCardExpiryDate = new Date(this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].TaxCardExpiryDate.value).toLocaleDateString('en-US');
      this.UpdatedSupplier.TaxCardExpiryDate = new Date(Date.parse(selectedTaxCardExpiryDate + this.fixedTimeGMT));
    }

    // this.UpdatedSupplier.VATRegistrationDate = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].VATRegistrationDate.value;
    // if (this.supplierRegistrationForm.value.BasicSupplierInfoTab.VATRegistrationDate) {
    if (this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].VATRegistrationDate.value) {
      var selectedVATRegistrationDate = new Date(this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].VATRegistrationDate.value).toLocaleDateString('en-US');
      this.UpdatedSupplier.VATRegistrationDate = new Date(Date.parse(selectedVATRegistrationDate + this.fixedTimeGMT));
    }

    // this.UpdatedSupplier.ActivityLegalRecordRegistrationDate = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ActivityLegalRecordRegistrationDate.value;
    // if (this.supplierRegistrationForm.value.BasicSupplierInfoTab.ActivityLegalRecordRegistrationDate) {
    if (this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ActivityLegalRecordRegistrationDate.value) {
      var selectedActivityLegalRecordRegistrationDate = new Date(this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ActivityLegalRecordRegistrationDate.value).toLocaleDateString('en-US');
      this.UpdatedSupplier.ActivityLegalRecordRegistrationDate = new Date(Date.parse(selectedActivityLegalRecordRegistrationDate + this.fixedTimeGMT));
    }

    // this.UpdatedSupplier.CompanyEstablishingDate = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CompanyEstablishingDate.value;
    // if (this.supplierRegistrationForm.value.BasicSupplierInfoTab.CompanyEstablishingDate) {
    if (this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CompanyEstablishingDate.value) {
      var selectedCompanyEstablishingDate = new Date(this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].CompanyEstablishingDate.value).toLocaleDateString('en-US');
      this.UpdatedSupplier.CompanyEstablishingDate = new Date(Date.parse(selectedCompanyEstablishingDate + this.fixedTimeGMT));
    }






    //Contractor Info
    this.UpdatedSupplier.ConstructionNumber = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ConstructionNumber.value;
    this.UpdatedSupplier.ContractorCategoryId = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ContractorCategoryId.value;
    this.UpdatedSupplier.ContractorClassificationId = this.supplierRegistrationForm.controls.BasicSupplierInfoTab['controls'].ContractorClassificationId.value;

    //ContactInfo
    this.UpdatedSupplier.Address = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].Address.value;
    this.UpdatedSupplier.PostalCode = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].PostalCode.value;
    this.UpdatedSupplier.ContactPersonName = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].ContactPersonName.value;
    this.UpdatedSupplier.Phone = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].Phone.value;
    this.UpdatedSupplier.Fax = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].Fax.value;
    this.UpdatedSupplier.ContactPersonEmail = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].ContactPersonEmail.value;
    this.UpdatedSupplier.GovernorateId = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].GovernorateId.value;
    this.UpdatedSupplier.WebSiteURL = this.supplierRegistrationForm.controls.ContactInfoTab['controls'].WebSiteURL.value;

    //Maintenance Info
    this.UpdatedSupplier.MaintenanceCenterAddress = this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].MaintenanceContactPerson.value;
    this.UpdatedSupplier.MaintenanceContactPerson = this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].MaintenanceContactPerson.value;
    this.UpdatedSupplier.MaintenancePhone = this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].MaintenancePhone.value;
    this.UpdatedSupplier.MaintenanceFax = this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].MaintenanceFax.value;
    this.UpdatedSupplier.AccountStatusId = null; // this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].AccountStatusId.value;
    this.UpdatedSupplier.DisableReason = null; //this.supplierRegistrationForm.controls.SupplierMaintenanceTab['controls'].DisableReason;

    //Attachments
    if (this.UpdatedSupplier.SupplierTypeId == 2) {
      //Industrial
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierCommericalRecord);
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierConstructorCategory);
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierConstructorClassification);
    } else if (this.UpdatedSupplier.SupplierTypeId == 1) {
      //Commercial
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierConstructorCategory);
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierConstructorClassification);
    }
    this.UpdatedSupplier.SupplierAttachments = this.supplierRegistrationFormAttachments;
    //Supplier Banks

    this.UpdatedSupplier.SupplierBanks = this.supplierRegistrationForm['controls']['SupplierBanks']['controls'].map(function (obj) {
      return {
        BankId: +obj['controls']['BankId'].value,
        BankBranch: obj['controls']['BankBranch'].value,
        AccountNumber: obj['controls']['AccountNumber'].value
      }
    });
    //Supplier Specialities
    this.UpdatedSupplier.DeletedSupplierSpecialities = this.deletedSupplierSpecialities;
    this.UpdatedSupplier.SupplierSpecialities = this.supplierRegistrationForm['controls']['SupplierSpecialities']['controls'].map(function (obj) {
      return {
        CategoryId: +obj['controls']['CategoryId'].value[0].Id,
        SpecialityId: +obj['controls']['SpecialityId'].value,
        ContactPerson: obj['controls']['CategoryContactPerson'].value,
        Email: obj['controls']['CategoryEmail'].value,
        Fax: obj['controls']['CategoryFax'].value,
        Mobile: obj['controls']['CategoryMobile'].value,
        // Address: obj['controls']['CategoryAddress'].value,
        ExperienceCopyURL: obj['controls']['CategoryExperienceCopyURL'].value,
        ExperienceCopyName: obj['controls']['CategoryExperienceCopyName'].value,
        Speciality: null,
        Supplier: null,
        ETenderSuppliers: null,
        Status: obj['controls']['Status'].value
      }
    });
    this.UpdatedSupplier.SupplierSpecialities = this.UpdatedSupplier.SupplierSpecialities.filter(ss => ss.Status == 1 || ss.Status.toString() == "");

    for (let i = 0; i < this.UpdatedSupplier.SupplierSpecialities.length; i++) {
      if (this.UpdatedSupplier.SupplierSpecialities[i].Status.toString() == "") {
        this.UpdatedSupplier.SupplierSpecialities[i].Status = +this.UpdatedSupplier.SupplierSpecialities[i].Status;
      }
    }

      //Supplier Partnerships
      this.UpdatedSupplier.SupplierPartnerships = this.supplierRegistrationForm['controls']['SupplierPartnerships']['controls'].map(function (obj) {
        return {
          PartnerName: obj['controls']['PartnerName'].value,
          NationalityId: obj['controls']['NationalityId'].value,
          // RegisterationDate: obj['controls']['RegisterationDate'].value,
          // RegisterationDate: new Date(new Date(obj.value.RegisterationDate).toLocaleDateString() + ",12:00:00 PM"),
          RegisterationDate: new Date(new Date(obj['controls']['RegisterationDate'].value).toLocaleDateString('en-US') + ",12:00:00 PM"),
          PartnerWebsiteURL: obj['controls']['PartnerWebsiteURL'].value,
          SupplierCommercialAgencyCopyURL: obj['controls']['SupplierCommercialAgencyCopyURL'].value,
          SupplierCommercialAgencyCopyName: obj['controls']['SupplierCommercialAgencyCopyName'].value,
          SupplierPartnershipCategories: obj['controls']['SelectedSupplierPartnershipCategories']['value'].map(function (key) {
            return {
              CategoryId: key.Id
            }
          })
        }
      });


    //Supplier Certificates
    this.UpdatedSupplier.SupplierCertificates = this.supplierRegistrationForm['controls']['SupplierCertificates']['controls'].map(function (obj) {
      return {
        CertificateType: obj['controls']['CertificateTypeId'].value,
        CertificateTypeOther: obj['controls']['CertificateTypeOther'].value,
        DocumentName: obj['controls']['CertificateCopyName'].value,
        URL: obj['controls']['CertificateCopyURL'].value
      }
    });
    this.supplierService.EditSupplier(this.UpdatedSupplier).subscribe(
      data => this.responseObj = data,
      () => this.submitFail = true,
      () => this.EditSupplierCompleted()
    );
  }
  EditSupplierCompleted() {
    if (this.responseObj.Success) {
      this.editCompleted = true;
    } else {
      this.submitFail = true;
    }
    this.globalServices.isLoaderEnabled = false;
  }

  //#endregion
  //#region Helper Functions
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  TaxRecordNumberChange(event) {
    this.globalServices.isLoaderEnabled = true;
    let TaxRecordNumber = event.target.value;
    this.supplierService.CheckDuplicatedSupplierTaxRecordNumber(TaxRecordNumber)
      .subscribe(
        data => this.isTaxRecordNumberDuplicated = data,
        () => this.submitFail = true,
        () => this.CheckDuplicatedSupplierTaxRecordNumberCompleted()
      );
  }

  CheckDuplicatedSupplierTaxRecordNumberCompleted() {
    let taxRecordNumberControls = this.getFormControls["BasicSupplierInfoTab"]["controls"]["TaxRecordNumber"];
    if (this.isTaxRecordNumberDuplicated) {
      taxRecordNumberControls.setErrors({ 'invalid': true });
    } else {

      taxRecordNumberControls.setValidators([Validators.required, Validators.pattern(this.taxRecordNumberRegex), Validators.maxLength(50)]);
      taxRecordNumberControls.updateValueAndValidity();
    }
    this.globalServices.isLoaderEnabled = false;
  }
  VATRegCheck(e){
    let VATNumberControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATNumber"];
    let VATRegistrationDateControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATRegistrationDate"];
    let VATRegistrationCopyControl = this.getFormControls["BasicSupplierInfoTab"]["controls"]["VATRegistrationCopy"];
    if(e.target.value == true)
    {
      VATNumberControl.setValue('');
      VATNumberControl.setValidators([Validators.required, Validators.pattern(this.taxRecordNumberRegex), Validators.maxLength(50), CustomValidators.textSpaceValidator()]);
      VATNumberControl.updateValueAndValidity();
      VATRegistrationDateControl.setValue('');
      VATRegistrationDateControl.setValidators([Validators.required, CustomValidators.pastDateValidator()]);
      VATRegistrationDateControl.updateValueAndValidity();
      VATRegistrationCopyControl.setValue('');
      VATRegistrationCopyControl.setValidators(Validators.required);
      VATRegistrationCopyControl.updateValueAndValidity();
    }else{
      VATNumberControl.setValue('');
      VATNumberControl.clearValidators();
      VATNumberControl.updateValueAndValidity();
      VATRegistrationDateControl.setValue(null);
      VATRegistrationDateControl.clearValidators();
      VATRegistrationDateControl.updateValueAndValidity();
      VATRegistrationCopyControl.setValue(null);
      VATRegistrationCopyControl.clearValidators();
      VATRegistrationCopyControl.updateValueAndValidity();
      this.supplierRegistrationFormAttachments = this.supplierRegistrationFormAttachments.filter(a => a.AttachmentTypeId !== AttachmentType.SupplierVATRegisteration);
    }
  }
  //#endregion
  //#endregion
}
